<template>
  <div class="page">
    <ion-grid class="page-content">
      <ion-row class="row-divider"></ion-row>
      <ion-row class="rectangle">
        <ion-col>
          <ion-row align-items-stretch>
            <ion-col size="12" class="col-padding">
              <ion-label class="light-text">Enter the OTP</ion-label>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col size="12" class="col-padding">
              <div class="border-line">
                <ion-col size="12">
                   <ion-input
                    size="6"
                    type="tel"
                    id="otp"
                    v-model="otp"
                    autofocus
                    placeholder="* * * *"
                    maxlength="4"
                    @input="otpController"
                    class="otp-input"
                  ></ion-input>
                  <!-- <ion-input
                    size="3"
                    type="tel"
                    autofocus="true"
                    id="otp1"
                    #otp1
                    placeholder="*"
                    required
                    maxlength="1"
                    @input="otp1 = $event.target.value"
                    @keyup="otpController($event, 'otp2')"
                  ></ion-input> -->
                  <!-- <ion-input
                    size="3"
                    type="tel"
                    id="otp2"
                    #otp2
                    placeholder="*"
                    required
                    maxlength="1"
                    @input="otp2 = $event.target.value"
                    @keyup="otpController($event, 'otp3')"
                  ></ion-input> -->
                  <!-- <ion-input
                    size="3"
                    type="tel"
                    id="otp3"
                    #otp3
                    placeholder="*"
                    required
                    maxlength="1"
                    @input="otp3 = $event.target.value"
                    @keyup="otpController($event, 'otp4')"
                  ></ion-input> -->
                  <!-- <ion-input
                    size="3"
                    type="tel"
                    id="otp4"
                    #otp4
                    placeholder="*"
                    required
                    maxlength="1"
                    @input="otp4 = $event.target.value"
                    @keyup="otpController($event, undefined)"
                  ></ion-input> -->
                </ion-col>
              </div>
            </ion-col>
          </ion-row>
          <ion-row class= "ion-text-center row-margin">
            <ion-col>
              <ion-label class="primary-text-link" @click="resendOtp">
                Resend OTP
                <span v-if="disableotp">( {{counter}} )</span>
              </ion-label>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { IonCol, IonGrid, IonInput, IonLabel, IonRow, IonSpinner } from "@ionic/vue";
import { AuthenticationService } from "../../service/account/authenticator.service"; 

export default defineComponent ({
  name: 'globalotp',
  components: {
    IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSpinner
  },
  data() {
    return {
      loaderTab: true,
      counter: 0,
      disableotp: true,
      mobile: "",
      otp: "",
      // otp1: "",
      // otp2: "",
      // otp3: "",
      // otp4: "",
      otpInd: false,
      otpReason: "",
      lastPath: null
    }
  },
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.lastPath = this.$router.options.history.state.back
    let otpInfo = localStorage.getItem("otpInfo")
    this.mobile = new LocalStorage().mobile;
    
    this.startCountdown(30);
    // this.setFirstFocus();
    this.loaderTab = false;
  },
  
  methods: {
    // setFirstFocus() {
    //   document.getElementById("otp1").setFocus();
    // },
    startCountdown(seconds) {
      this.counter = seconds;
      var interval = setInterval(() => {
        this.counter--;
        if (this.counter <= 0) {
          // The code here will run when
          // the timer has reached zero.
          clearInterval(interval);
          this.disableotp = false;
        }
      }, 1000);
    },
    // async resendOtp() {
    //   if (!this.disableotp) {
    //     if(this.lastPath == "/login"){
    //       try {
    //         let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    //         let otp = await new AuthenticationService().resendOtpForUser(
    //             userInfo
    //         );
    //         new ToastUtils().presentToast("OTP resent to your mobile number");
    //         this.disableotp = true;
    //         this.startCountdown(30);
    //       } catch (error) {
    //           let serviceError = migratedTryParseServiceError(error);
    //           new ToastUtils().presentToast(serviceError.description);
    //           if (serviceError.code == "U10010") {
    //             this.loaderTab = false;
    //             window.localStorage.clear();
    //             this.$router.go(-1);
    //           } else {
    //             this.otpInd = false;
    //             this.loaderTab = false;
    //             document.getElementById("otp1").value = null;
    //             document.getElementById("otp2").value = null;
    //             document.getElementById("otp3").value = null;
    //             document.getElementById("otp4").value = null;
    //             this.otp1 = "";
    //             this.otp2 = "";
    //             this.otp3 = "";
    //             this.otp4 = "";
    //             document.getElementById("otp1").setFocus();
    //           }
    //       }
    //     } else {
    //       try {
    //         await new EVCStationReservationService().startChargingReservationByUser(
    //           { id: this.$route.params.bookingId },
    //           new LocalStorage().user
    //         );
    //         new ToastUtils().presentToast("OTP resent to your mobile number");
    //         this.disableotp = true;
    //         this.startCountdown(30);
    //       } catch (error) {
    //         // let serviceError = tryParseServiceError(error);
    //         // new AlertUtils().presentAlert(serviceError ? serviceError : error);
    //         let serviceError = migratedTryParseServiceError(error);
    //         new ToastUtils().presentToast(serviceError.description);
            
    //       }
    //     }
    //   }
    // },

    async resendOtp() {
      if (!this.disableotp) {
        try {
          if (this.lastPath === "/login") {
            const userInfo = JSON.parse(localStorage.getItem('userInfo'));
            await new AuthenticationService().resendOtpForUser(userInfo);
          } else {
            await new EVCStationReservationService().startChargingReservationByUser(
              { id: this.$route.params.bookingId },
              new LocalStorage().user
            );
          }

          new ToastUtils().presentToast("OTP resent to your mobile number");
          this.disableotp = true;
          this.startCountdown(30);
        } catch (error) {
          const serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        }
      }
    },

    // async otpController(event, next) {
    //   try {
    //     if (event.target.value.length > 0) {
    //       if (next) {
    //         document.getElementById(next).setFocus();
    //       } else {
    //         this.otp = this.otp1 + this.otp2 + this.otp3 + this.otp4;
    //         if (this.otp.length == 4 && this.otpInd == false) {
    //           if(this.lastPath == '/login'){
    //             this.loaderTab = true;
    //             this.otpInd = true;
    //             let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    //             // window.localStorage.clear();
    //             await new AuthenticationService().verifyOtpForSignin(userInfo.id, this.otp);
    //             new ToastUtils().presentToast("Successfully logged in");
    //             this.$store.dispatch("logIn", new LocalStorage().user);
    //             this.$router.push({
    //               path: "/"
    //             });
    //           } else {
    //             this.loaderTab = true;
    //             this.otpInd = true;
                
    //             let otpData = { 
    //               id: this.$route.params.bookingId,
    //               otpReason: this.$route.params.otpReason,
    //               otpDetails: this.$route.params.otpDetails
    //             }
    //             await new EVCStationReservationService().verifyGlobalOtp(
    //               this.otp,
    //               otpData,
    //               new LocalStorage().user
    //             );
    //             // localStorage.setItem("verifystart", "true");
    //             this.loaderTab = false;
    //             new ToastUtils().presentToast("Reservation cancelled successfully");
    //             this.$router.go(-1);
    //           }
    //         }
    //       }
    //     }
    //   } catch (error) {
    //     let serviceError = migratedTryParseServiceError(error);
    //     new ToastUtils().presentToast(serviceError.description);
    //     // new AlertUtils().presentAlert(
    //     //   serviceError ? serviceError : error
    //     // );
    //     new ToastUtils().presentToast(serviceError.description);
    //     this.loaderTab = false;
         
    //     if (serviceError.code != "U10009") {
    //       this.loaderTab = false;
    //       window.localStorage.clear();
    //       this.$router.go(-1);
    //     } else {
    //       this.otpInd = false;
    //       this.loaderTab = false;
    //       document.getElementById("otp1").value = null;
    //       document.getElementById("otp2").value = null;
    //       document.getElementById("otp3").value = null;
    //       document.getElementById("otp4").value = null;
    //       this.otp1 = "";
    //       this.otp2 = "";
    //       this.otp3 = "";
    //       this.otp4 = "";
    //       document.getElementById("otp1").setFocus();
    //     }
    //   }
    // },

    async otpController() {
      if (this.otp.length === 4 && !this.otpInd) {
        this.loaderTab = true;
        this.otpInd = true;

        try {
          if (this.lastPath === '/login') {
            const userInfo = JSON.parse(localStorage.getItem("userInfo"));
            await new AuthenticationService().verifyOtpForSignin(userInfo.id, this.otp);
            new ToastUtils().presentToast("Successfully logged in");
            this.$store.dispatch("logIn", new LocalStorage().user);
            this.$router.push({ path: "/" });
          } else {
            const otpData = {
              id: this.$route.params.bookingId,
              otpReason: this.$route.params.otpReason,
              otpDetails: this.$route.params.otpDetails
            };
            await new EVCStationReservationService().verifyGlobalOtp(this.otp, otpData, new LocalStorage().user);
            new ToastUtils().presentToast("Reservation cancelled successfully");
            this.$router.go(-1);
          }
        } catch (error) {
          const serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
          this.loaderTab = false;
          
          if (serviceError.code !== "U10009") {
            window.localStorage.clear();
            this.$router.go(-1);
          } else {
            this.otp = "";
            this.otpInd = false;
            document.getElementById("otp").setFocus();
          }
        }
      }
    }
  },
})
</script>

<style scoped>
ion-input {
  --highlight-color-focused : none;
  --highlight-color-valid : none;
  display: inline-block;
  width: 310px;
  height: 48px;
  margin: 1px;
  --background: #ffffff;
  --padding-start: 7px;
  /* text-align: center; */
}
.otp-input {
  letter-spacing: 10px; 
  font-size: 17px;      
  text-align: center;    
}

</style>